import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CalculationSettingsModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-calculation',
  templateUrl: './calculation.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class CalculationComponent implements OnInit {

  configurationController : ConfigurationService;
  form : FormGroup;
  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    public bsModalRef : BsModalRef,
    private endpointsService: EndpointsService,
    private readonly modalService: ModalControlService,
    private readonly modelConfirmationMessage: ModalConfirmationService) {
      this.configurationController = configurationController;
     }
  
  adminRole: boolean = false;

  distanceToNavaidOriginalValue: number;

  ngOnInit(): void {
    this.configurationController.saveChangesState();
    this.adminRole = UtilsService.getIsAdminFromJwtToken(this.endpointsService.getUserRolesToken());
    this.form = new FormGroup({
      kfactor : new FormControl(this.configurationController.currentConfiguration.calculation.kfactor,[Validators.min(1),Validators.max(1.5)]),
      azimutIncrement : new FormControl(),
      sectorLength : new FormControl(),
      summitGranularity : new FormControl(),
      visibilityGranularity : new FormControl(),
      visibilityScaling : new FormControl(),
      fillterrainVoids : new FormControl(),
      coneOfSilence : new FormControl(this.configurationController.currentConfiguration.calculation.coneOfSilenceDefa,[Validators.min(5),Validators.max(60)]),
      useConeOfSilence : new FormControl(),
      elevationType : new FormControl(),
      useSectorization : new FormControl(),
      rangeLimitation : new FormControl({disabled: !this.adminRole}),
      algorithm : new FormControl(),
      calculateNegativeScreeningAngles : new FormControl(),
      distanceToNavaid : new FormControl(this.configurationController.currentConfiguration.calculation.distanceToNavAid,[Validators.min(0),Validators.max(500)]),
    })
    this.distanceToNavaidOriginalValue = this.configurationController.currentConfiguration.calculation.distanceToNavAid;
    if (!this.configurationController.currentConfiguration.calculation.calculateNegAngles){
      this.form.controls.distanceToNavaid.disable();
    }
  }

  retoreDefaults(){
    let calculationConfiguration: CalculationSettingsModel = new CalculationSettingsModel();

    calculationConfiguration.kfactor = 1.3;
    calculationConfiguration.azimuthIncrement = 0.3;
    calculationConfiguration.sectorLength = 500;
    calculationConfiguration.summitGranularity = 1;
    calculationConfiguration.visibilityGranularity = 30;
    calculationConfiguration.visibilityScaling = "1x1";
    calculationConfiguration.autoFillTerrainVoids = true;
    calculationConfiguration.coneOfSilenceDefa = 50;
    calculationConfiguration.useConeOfSilence = false;
    calculationConfiguration.elevationType = "Relative";
    calculationConfiguration.useSectorization = true;
    calculationConfiguration.rangeLimitation = "DOC";
    calculationConfiguration.algorithm = "Screening";
    calculationConfiguration.calculateNegAngles = false;
    calculationConfiguration.distanceToNavAid = 20;

    this.configurationController.currentConfiguration.calculation = calculationConfiguration;
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.configurationController.cancelConfigurationPopup();
    hideModal? this.bsModalRef.hide(): false;
  }

  async saveConfiguration():Promise<void> {
    if(this.projectService.projectEditable()){
      await this.configurationController.saveConfigurationPopup(this.form, true);
    }
    this.bsModalRef.hide();
  }

  negativeScreenAnglesSelect(event){
    if (event.currentTarget.checked){
      this.configurationController.currentConfiguration.calculation.algorithm = "Visibility";
      this.form.controls.distanceToNavaid.enable();
    } else {
      this.form.controls.distanceToNavaid.disable();
      this.configurationController.currentConfiguration.calculation.distanceToNavAid = this.distanceToNavaidOriginalValue;
    }
  }

  coverageAlgorithmSelect(event){
    if (event.currentTarget.value == "Screening"){
      this.configurationController.currentConfiguration.calculation.useConeOfSilence = false;
      this.configurationController.currentConfiguration.calculation.calculateNegAngles = false;
      this.form.controls.distanceToNavaid.disable();
    }
  }

  useConeOfSilenceSelect(event){
    if (event.currentTarget.checked){
      this.configurationController.currentConfiguration.calculation.algorithm = "Visibility";
    }
  }

  async deleteCalculationsDatabase() {
    const success = await this.configurationController.deleteCalculationsDatabase("Deleting calculation database will delete all data from previous calculations. Do you wish to continue?");
    if (success) {
      this.modalService.showMesssageModal("Calculation Database", "Calculation Database deleted successfully.")
    }
  }
}
